export const getList = (state) => state.list;
export const getDocumentTemplate = (state) => state.documentTemplate;
